import { render, staticRenderFns } from "./SlideSetting.vue?vue&type=template&id=34ba3806"
import script from "./SlideSetting.vue?vue&type=script&lang=js"
export * from "./SlideSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports